const storageKey = 'scg-wishlist-v1';
let wishlist = [];
let storageAvailable = true;
function readWishlist() {
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
    wishlist = Array.isArray(saved) ? saved.filter(item => item && typeof item.handle === 'string' && /^[a-z0-9-]+$/i.test(item.handle)).slice(0,200) : [];
  } catch { wishlist = []; storageAvailable = false; }
}
function status(message) {
  document.querySelectorAll('[data-scg-wishlist-status],[data-scg-wishlist-live]').forEach(node => { node.textContent = message; });
}
function refreshButtons() {
  document.querySelectorAll("[data-scg-wishlist-count]").forEach(node => { node.textContent = String(wishlist.length); node.dataset.scgWishlistCount = String(wishlist.length); });
  document.querySelectorAll('[data-scg-save-product]').forEach(button => {
    const saved = wishlist.some(item => item.handle === button.dataset.handle);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${button.dataset.title} ${saved ? 'from' : 'to'} wishlist`);
    const label = button.querySelector('[data-scg-save-label]');
    if (label) label.textContent = saved ? 'Saved to wishlist' : 'Save to wishlist';
  });
}
function renderWishlist() {
  const grid = document.querySelector('[data-scg-wishlist-items]');
  if (!grid) return;
  document.querySelector('[data-scg-wishlist-empty]').hidden = wishlist.length > 0;
  grid.replaceChildren();
  const root = window.Shopify?.routes?.root || '/';
  wishlist.forEach(item => {
    const card = document.createElement('article');
    card.className = 'scg-wishlist-item';
    const link = document.createElement('a');
    link.href = `${root}products/${encodeURIComponent(item.handle)}`;
    if (typeof item.image === 'string' && (/^https:\/\//i.test(item.image) || item.image.startsWith('//'))) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title || item.handle;
      image.loading = 'lazy';
      link.append(image);
    }
    const heading = document.createElement('h2');
    heading.textContent = item.title || item.handle;
    link.append(heading);
    card.append(link);
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.dataset.scgWishlistRemove = item.handle;
    remove.textContent = 'Remove from wishlist';
    card.append(remove);
    grid.append(card);
  });
  if (!storageAvailable) status('Browser storage is unavailable. Please enable local storage to keep a wishlist on this device.');
}
function persist(next, message) {
  try { localStorage.setItem(storageKey, JSON.stringify(next)); }
  catch { storageAvailable = false; status('Your browser could not save this wishlist. Please enable local storage and try again.'); return; }
  wishlist = next;
  refreshButtons();
  renderWishlist();
  status(message);
}
document.addEventListener('click', event => {
  const save = event.target.closest('[data-scg-save-product]');
  const remove = event.target.closest('[data-scg-wishlist-remove]');
  if (!save && !remove) return;
  event.preventDefault();
  event.stopPropagation();
  if (remove) {
    persist(wishlist.filter(item => item.handle !== remove.dataset.scgWishlistRemove), 'Product removed from your wishlist.');
    return;
  }
  const handle = save.dataset.handle;
  if (!/^[a-z0-9-]+$/i.test(handle)) return;
  if (wishlist.some(item => item.handle === handle)) persist(wishlist.filter(item => item.handle !== handle), 'Product removed from your wishlist.');
  else if (wishlist.length < 200) persist([...wishlist, {handle,title:save.dataset.title,image:save.dataset.image}], 'Product saved to your wishlist.');
  else status('Your wishlist is full. Remove an item before saving another.');
}, true);
window.addEventListener('storage', event => {
  if (event.key === storageKey) { readWishlist(); refreshButtons(); renderWishlist(); }
});
new MutationObserver(records => {
  if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-scg-save-product]') || node.querySelector('[data-scg-save-product]'))))) refreshButtons();
}).observe(document.body, {childList:true,subtree:true});
readWishlist();
refreshButtons();
renderWishlist();
